module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[55]54.561158a.woff2";